export default __webpack_public_path__ + "static/media/registration-bg.e6e2d322.png";